module.exports = __webpack_public_path__ + "img/LogoInspecta2.36451cb3.png";